import React, { useState } from 'react';
import DownloadIconWhite from 'assets/icons/download-icon-white.svg';
import VideoIcon from 'assets/icons/video-icon.svg';
import VideoIconWhite from 'assets/icons/video-icon-white.svg';
import DocumentIcon from 'assets/icons/document-icon.svg';
import ImgIcon from 'assets/icons/img-icon.svg';
import ImgIconWhite from 'assets/icons/img-icon-white.svg';
import SettingsIconWhite from 'assets/icons/settings-icon-white.svg';
import SettingsIconBlack from 'assets/icons/settings-icon-black.svg';
import DocumentIconWhite from 'assets/icons/document-icon-white.svg';
import ArrowBackWhite from 'assets/icons/arrow-back-white.svg';
import Modal from 'react-modal';
import navLeft from 'assets/icons/navigate-left.svg';
import navRight from 'assets/icons/navigate-right.svg';
import { MEDIA_TYPES } from 'types';
import { Document, Page, pdfjs } from 'react-pdf';
import { useTranslation } from 'react-i18next';
import { translations as _ } from 'locales/translations';
import Vimeo from '@u-wave/react-vimeo';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

Modal.setAppElement(document.getElementById('root'));

interface propsModalShowMedia {
  currentElement: any;
  setCurrentElement: any;
  mediaKey: string;
  mediaElements: any;
  isOpenModal: boolean;
  setIsOpenModal: (value: boolean) => void;
}

export default function ModalShowMedia({
  currentElement,
  setCurrentElement,
  mediaKey,
  mediaElements,
  setIsOpenModal,
  isOpenModal,
}: propsModalShowMedia) {
  const [indexNav, setIndexNav] = useState(0);
  const [numPages, setNumPages] = useState(null);
  const { t } = useTranslation();
  const i18nKey = _.productDetail;

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  function navigateModal(index) {
    setIndexNav(index);
    setCurrentElement(mediaElements.medias[index]);
  }

  function getIDVideo(url) {
    var match = /vimeo.*\/(\d+)/i.exec(url);
    if (match) {
      return match[1];
    } else {
      return -1;
    }
  }

  function showPrev() {
    return indexNav > 0;
  }

  function showNext() {
    return indexNav < mediaElements.medias?.length - 1;
  }

  function getImageType(name, isWhite = false) {
    switch (name.split('.').pop().toLowerCase()) {
      case 'pdf':
        return isWhite ? DocumentIconWhite : DocumentIcon;
      case 'jpeg':
      case 'jpg':
      case 'png':
        return isWhite ? ImgIconWhite : ImgIcon;
      case 'exe':
        return isWhite ? SettingsIconWhite : SettingsIconBlack;
      default:
        return isWhite ? VideoIconWhite : VideoIcon;
    }
  }

  function returnExtention(element) {
    let extention = element.split('.').pop().toLowerCase();
    if (['jpg', 'jpeg', 'png'].includes(extention)) {
      return 'picture';
    } else if (['pdf'].includes(extention)) {
      return 'pdf';
    }
  }

  const { innerWidth: width } = window;

  return (
    <Modal
      isOpen={isOpenModal}
      onRequestClose={() => setIsOpenModal(false)}
      contentLabel="Example Modal"
      className="modalDetail"
      overlayClassName="modalDetail-overlay"
    >
      <div className="modalDetail-north">
        <div className="modalDetail-north-name">
          <img
            onClick={() => setIsOpenModal(false)}
            alt="back"
            src={ArrowBackWhite}
          />
          <img
            alt="download"
            id="document"
            src={getImageType(currentElement?.name, true)}
          />
        </div>
        {mediaKey !== MEDIA_TYPES.VIDEO && (
          <div className="modalDetail-north-action">
            <a
              className="modalDetail-north-download"
              href={currentElement?.link_value}
              download
            >
              <img alt="download" id="download" src={DownloadIconWhite} />{' '}
              {t(i18nKey.download)}
            </a>
          </div>
        )}
        {currentElement.link_text && (
          <div className="modalDetail-north-action">
            <a
              className="modalDetail-north-download"
              href={currentElement?.link_value}
              target={'_BLANK'}
              rel="noreferrer"
            >
              <img alt="download" className="video" src={VideoIconWhite} />{' '}
              {t(i18nKey.vimeo)}
            </a>
          </div>
        )}
      </div>
      <div
        className={`modalDetail-south ${returnExtention(currentElement.name)}`}
      >
        <div className="modalDetail-south-left">
          {showPrev() && (
            <img
              onClick={() => {
                navigateModal(indexNav - 1);
              }}
              alt="left"
              src={navLeft}
            />
          )}
        </div>
        <div className="modalDetail-south-middle">
          {returnExtention(currentElement.name) === 'picture' && (
            <img src={currentElement.link_value} alt="" />
          )}
          {mediaKey !== (MEDIA_TYPES.PICTURE && MEDIA_TYPES.VIDEO) &&
            returnExtention(currentElement.name) === 'pdf' && (
              <div>
                <Document
                  loading={t(i18nKey.loading)}
                  file={currentElement.link_value}
                  onLoadSuccess={onDocumentLoadSuccess}
                  className="doc-pdf-container"
                >
                  {[...Array(numPages)].map((el, i) => {
                    return (
                      <Page
                        key={el}
                        loading=""
                        pageNumber={i + 1}
                        scale={0.65}
                        width={width * 0.8}
                      />
                    );
                  })}
                </Document>
              </div>
            )}
          {mediaKey === MEDIA_TYPES.VIDEO && (
            <Vimeo
              video={getIDVideo(currentElement.link_value)}
              autoplay
              height={500}
              volume={0}
            />
          )}
        </div>
        <div className="modalDetail-south-right">
          {showNext() && (
            <img
              onClick={() => {
                navigateModal(indexNav + 1);
              }}
              alt="left"
              src={navRight}
            />
          )}
        </div>
      </div>
    </Modal>
  );
}
